module.exports = __webpack_public_path__ + "img/pr-5.66e11e03.png";